const RECAPTCHA_API_KEY = '6Lfo0h4UAAAAAEo1t9mcy4pzeQwDWdAYxomiW_kA';
const GOOGLE_ANALYTICS_TID = 'UA-80108-1';
const GOOGLE_MAPS_API_KEY = 'AIzaSyB2zCv_96w-RcZ2JUyW2TwGWmhjMNA6HSY';

export {
    RECAPTCHA_API_KEY,
    GOOGLE_ANALYTICS_TID,
    GOOGLE_MAPS_API_KEY
}